import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { Carousel, CarouselContent, CarouselItem } from '../ui/carousel';

const RelatedProducts = props => {
  const { slides, classes, children } = props;

  const { isMobile } = useIsMobile();

  if (slides.length === 0) {
    return null;
  }

  return (
    <div className={cn('w-full', classes.root)}>
      <div className={cn('lg_grid lg_grid-cols-3 lg_gap-x-[45px]', classes.content)}>
        {isMobile ? (
          <MobileCarousel
            slides={slides}
            children={children}
          />
        ) : (
          <>{slides.map((item, index) => children(item, index))}</>
        )}
      </div>
    </div>
  );
};

const MobileCarousel = props => {
  const { slides, children } = props;

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [api, setApi] = useState(null);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  useEffect(() => {
    if (!api) return;

    const onSelect = emblaApi => {
      if (!emblaApi) return;

      setSelectedIndex(emblaApi.selectedScrollSnap());
      setCanScrollPrev(api.canScrollPrev());
      setCanScrollNext(api.canScrollNext());
    };

    onSelect(api);
    api.on('reInit', onSelect).on('select', onSelect);
  }, [api]);

  return (
    <>
      <Carousel
        opts={{ align: 'start' }}
        setApi={setApi}
      >
        <CarouselContent className='-ml-5'>
          {slides.map((item, index, arr) => {
            const isLastOne = index === arr.length - 1;

            return (
              <CarouselItem
                key={item.id}
                className={clsx(isLastOne ? 'basis-[330px] pl-5' : 'basis-[330px] pl-5')}
              >
                {children(item, index)}
              </CarouselItem>
            );
          })}
        </CarouselContent>
      </Carousel>
      {(canScrollPrev || canScrollNext) && slides.length > 1 ? (
        <div className=''>
          <div className='relative mt-5 h-[1px] bg-e0e0e0  '>
            <div
              className='absolute left-0 top-1/2 h-[3px] -translate-y-1/2 bg-black transition-[width] duration-2xl ease-linear'
              style={{
                width: `${Math.min(100, Math.floor(((selectedIndex + 1) / slides.length) * 100))}%`,
              }}
            ></div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default RelatedProducts;
